import React, { useState, useEffect, useContext } from "react";
import { StyleSheet, View, Platform } from "react-native";
import moment from "moment";

import Utils, { getWeekInterval } from "../../../../helpers/utils";

import Header from "../../common/header/index";
import ReflectionContext from "../ReflectionContext";
import Icons from "../../common/icons/index";
import Toggle from "../../common/Toggle";
import AppTheme from "../../AppTheme";

import FORMATS from "../header/formats";
const DATE_FORMAT = "YYYY-MM-DD";

export default function ComparisonHeader({ isLoading, title }) {
  const {
    controller,
    showTutorials,
    showReflectionTutorials,
    timeUnit,
    selectedDate: selected_date,
    filterByDate,
    goBack,
  } = useContext(ReflectionContext) || {};

  const [showBackIcon, setShowBackIcon] = useState(false);
  const [intervalColumns, setIntervalColumns] = useState(null);
  const [selectedTimeUnit, setSelectedTimeUnit] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [subTitle, setSubTitle] = useState("");

  useEffect(() => {
    if (!timeUnit) return;

    const unit = timeUnit === "week" ? "isoweek" : timeUnit;

    const firstDay = moment(selected_date).endOf(unit);
    const now = Utils.nowUserTz(controller).endOf(unit);
    setShowBackIcon(now.diff(firstDay, `${timeUnit}s`) > 0);

    setSelectedTimeUnit(timeUnit);
    setSelectedDate(firstDay);
    initIntervals();
    updateIntervalName(firstDay, timeUnit);
  }, [selected_date, timeUnit]);

  const initIntervals = () => {
    setIntervalColumns(Object.keys(FORMATS));
  };

  const travelInTime = (offset, isEnabled = true) => {
    if (showTutorials || showReflectionTutorials) return;
    if (!isEnabled) return;

    //  Add 1 week/day/year
    let newDate = moment(selectedDate).add(selectedTimeUnit, offset);

    // Update results
    filterByDate(newDate.format(DATE_FORMAT), selectedTimeUnit);
  };

  const onPickerValueChanged = (tu) => {
    if (showTutorials || showReflectionTutorials) return;

    setSelectedTimeUnit(tu);
    setShowBackIcon(true);
    const newDate = Utils.nowUserTz(controller).startOf(
      tu === "week" ? "isoWeek" : tu,
    );

    // Update results
    filterByDate(newDate.format(DATE_FORMAT), tu);
  };

  const updateIntervalName = (userDate, tu) => {
    const format = FORMATS[tu]?.displayFormat;

    // Week is tricky
    if (tu === "week") {
      setSubTitle(getWeekInterval(userDate, format));
    } else {
      const currentQ = moment().format(FORMATS.quarter.format);

      setSubTitle(
        Utils.formatDateByTimeUnit({
          date: userDate,
          timeUnit: tu,
          format,
          currentInterval: tu == "quarter" ? currentQ : null,
        }),
      );
    }
  };

  return (
    <View>
      <Header
        controller={controller}
        title={title}
        subTitle={subTitle}
        isLoading={isLoading}
        style={styles.header}
        goBack={goBack}
      >
        <View style={styles.container}>
          {/* Intervals */}
          <View style={styles.intervals}>
            {intervalColumns ? (
              <Toggle
                selected={selectedTimeUnit}
                options={intervalColumns}
                onToggle={(value) => onPickerValueChanged(value)}
                style={{
                  backgroundColor: "#f3f2f1",
                  height: 24,
                  width: 260,
                }}
              />
            ) : null}
          </View>

          <View style={styles.rightContainer}>
            <Icons.ArrowLeft
              style={styles.arrowLeft}
              fillColor={AppTheme.iconBlack}
              onPress={() => travelInTime(-1)}
            />

            <Icons.ArrowRight
              style={[styles.arrowRight, { opacity: showBackIcon ? 1 : 0.5 }]}
              fillColor={AppTheme.iconBlack}
              onPress={() => travelInTime(1, showBackIcon)}
            />
          </View>
        </View>
      </Header>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    ...Platform.select({
      web: {
        minHeight: 88,
        paddingTop: 10,
        paddingBottom: 0,
      },
      ios: {
        minHeight: 120,
        paddingTop: 52,
      },
      android: {
        paddingTop: 16,
      },
    }),
  },
  container: {
    height: 40,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    zIndex: 2,
    backgroundColor: AppTheme.headerBg,
    paddingLeft: 16,
    paddingRight: 12,
  },
  intervals: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    paddingRight: 10,
    flex: 1,
  },
  rightContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    height: 40,
    minWidth: 40,
  },
  arrowLeft: {},
  arrowRight: {},
  gemStyles: {
    height: 35,
    width: 35,
    borderRadius: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#FFF",
  },
});
